import React from "react";
import "./Clients.css";
import { Award, Star } from "lucide-react";

import deloitelogo from "../assets/Logo_of_Deloitte.svg (1).png";
import undpLogo from "../assets/undp_logo_landscape.png";
import kcbLogo from "../assets/KCB_Bank_Kenya_Limited_logo.png";
import safaricomLogo from "../assets/safaricom-logo_brandlogos.net_kykbd.png";
import kplcLogo from "../assets/officialLogo.png";
import ministryLogo from "../assets/MicrosoftTeams-image.png";
import eadbankLogo from "../assets/logo (2).png";
import africaDevBank from "../assets/images (2).jpeg";
import stanBankLogo from "../assets/images (2).png";
import eqtLogo from "../assets/equity-bank-logo.png";

/* PLACEHOLDER LOGO IMPORTS */
import airtelLogo from "../assets/airtel.png";
import technoserveLogo from "../assets/technoserve.png";
import vikeLogo from "../assets/vike.webp";
import pacisLogo from "../assets/pacis.png";
// import smeoLogo from "../assets/smeo.png";
import realAfricaLogo from "../assets/realafrica.png";
// import migotiyoLogo from "../assets/migotiyo.png";
import ministryFinanceLogo from "../assets/ministryfinance.png";
import enkishonLogo from "../assets/enkishon.png";
import enkangLogo from "../assets/enkang.png";
// import trustIndustriesLogo from "../assets/trustindustries.png";
import uapLogo from "../assets/uap.png";
// import gatewayLogo from "../assets/gateway.png";
import biblicaLogo from "../assets/biblica.png";
// import afribonLogo from "../assets/afribon.png";
// import peninsulaLogo from "../assets/peninsula.png";
import safariClubLogo from "../assets/safariclub.png";
import kilimoHaiLogo from "../assets/kilimohai.jpg";
// import elciLogo from "../assets/elci.png";
import apaLogo from "../assets/apa.jpg";
// import uapInsuranceLogo from "../assets/uapinsurance.png";
// import indraLogo from "../assets/indra.png";
import mellechLogo from "../assets/mellech.png";
import unfpaLogo from "../assets/unfpa.png";
// import unidoLogo from "../assets/unido.png";
import dhlLogo from "../assets/dhll.jpeg";
import usaidLogo from "../assets/usaid.png";
import urgentCargoLogo from "../assets/urgentcargo.png";
import sanlamLogo from "../assets/sanlam.jpg";
import boaLogo from "../assets/boa.png";
import gulfBankLogo from "../assets/gulf.webp";
import forwardSaccoLogo from "../assets/forwardsacco.png";
import unSaccoLogo from "../assets/unsacco.png";
// import meeraLogo from "../assets/meera.png";

const clients = [
  { name: "Airtel", logo: airtelLogo },
  { name: "Technoserve", logo: technoserveLogo },
  { name: "Vike Insurance Brokers", logo: vikeLogo },
  { name: "Pacis Insurance", logo: pacisLogo },
  // { name: "SMEO", logo: smeoLogo },
  { name: "Real Africa Safaris", logo: realAfricaLogo },
  // { name: "Migotiyo Plantation", logo: migotiyoLogo },
  { name: "Ministry of Finance and Planning", logo: ministryFinanceLogo },
  { name: "Enkishon Group Limited", logo: enkishonLogo },
  { name: "Enkang", logo: enkangLogo },
  // { name: "Trust Industries Limited", logo: trustIndustriesLogo },
  { name: "UAP", logo: uapLogo },
  // { name: "Gateway International Limited", logo: gatewayLogo },
  { name: "Biblica", logo: biblicaLogo },
  // { name: "Afrikon", logo: afribonLogo },
  // { name: "Peninsula and Racecourse Gardens", logo: peninsulaLogo },
  { name: "Nairobi Safari Club", logo: safariClubLogo },
  { name: "Kilimo Hai", logo: kilimoHaiLogo },
  // { name: "ELCI", logo: elciLogo },
  { name: "APA Insurance", logo: apaLogo },
  // { name: "UAP Insurance", logo: uapInsuranceLogo },
  // { name: "Indra Company", logo: indraLogo },
  { name: "Mellech Group", logo: mellechLogo },

  /* Existing and added major orgs */
  { name: "Deloitte", logo: deloitelogo },
  { name: "UNDP", logo: undpLogo },
  { name: "UNFPA", logo: unfpaLogo },
  // { name: "UNIDO", logo: unidoLogo },
  { name: "DHL", logo: dhlLogo },
  { name: "USAID", logo: usaidLogo },
  { name: "Urgent Cargo Handling Limited", logo: urgentCargoLogo },
  { name: "Sanlam", logo: sanlamLogo },
  { name: "Bank of Africa", logo: boaLogo },
  { name: "KCB Bank", logo: kcbLogo },
  { name: "Equity Bank", logo: eqtLogo },
  { name: "Safaricom", logo: safaricomLogo },
  { name: "Gulf African Bank", logo: gulfBankLogo },
  { name: "Forward Sacco", logo: forwardSaccoLogo },
  { name: "UN Sacco", logo: unSaccoLogo },
  // { name: "Meera Construction Limited", logo: meeraLogo }
];

const awards = [
  {
    title: "Pan African Financial Warrior Award",
    year: "2019",
    description: "Recognized for contribution to African financial markets"
  },
  {
    title: "Excellence in Transaction Advisory",
    year: "2021",
    description: "Industry recognition for innovative deal structuring"
  }
];

function Clients() {
  return (
    <section className="clients-section" id="clients">
      <div className="clients-container">
        <div className="clients-header">
          <h2 className="clients-title">
            Trusted by <span className="accent">Industry Leaders</span>
          </h2>
          <p className="clients-subtext">
            Partnering with leading organizations across Africa
          </p>
        </div>

        <div className="clients-card">
          <div className="clients-grid">
            {clients.map((client, index) => (
              <div key={index} className="client-item">
                <img src={client.logo} alt={client.name} className="client-logo" />
              </div>
            ))}
          </div>
        </div>

        <div className="awards-section">
          <h2 className="awards-title">
            Awards and <span className="accent">Recognition</span>
          </h2>

          <div className="awards-grid">
            {awards.map((award, index) => (
              <div key={index} className="award-card">
                <div className="award-icon">
                  <Award size={30} className="accent-icon" />
                </div>
                <div className="award-content">
                  <div className="award-header">
                    <Star size={18} className="accent-icon" />
                    <span className="award-year">{award.year}</span>
                  </div>
                  <h3 className="award-title">{award.title}</h3>
                  <p className="award-desc">{award.description}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}

export default Clients;